import Avatar from '../Avatar';
import { getJobs, errorText } from '../api';
import { useLoad, when, agentFor } from '../fmt';

const COLS = [
  ['queued', 'Queued', ['queued']],
  ['working', 'Working', ['working']],
  ['you', 'Needs you', ['needs_you', 'failed']],
  ['done', 'Done today', ['done']],
];

// The time on a card: when the job started, when the employee asked the boss, or since when it has been waiting.
// (The last update moves with every progress step, so it is only used for finished jobs.)
function cardTime(t) {
  if (t.status === 'working') return `Started ${when(t.createdAt || t.updatedAt)}`;
  if (t.status === 'needs_you') return `Asked ${when(t.updatedAt || t.createdAt)}`;
  if (t.status === 'queued') return `Waiting since ${when(t.createdAt || t.updatedAt)}`;
  return when(t.updatedAt || t.createdAt);
}

export default function TaskBoard({ agentsById, onOpenAgent, version }) {
  const { data, error, loading } = useLoad(getJobs, [version]);
  const jobs = data || [];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
      <div className="vh"><div><h2>Task board</h2><p>Every job your employees are doing. Click a card to talk about it.</p></div></div>
      {error && <div className="err">{errorText(error)}</div>}
      {!error && !data && loading && <div className="panel empty">Loading…</div>}
      {!error && (data || !loading) && <div className="board">
        {COLS.map(([k, name, statuses]) => {
          const ts = jobs.filter((j) => statuses.includes(j.status));
          return (
            <div className={`aio-col ${k === 'you' ? 'you' : ''}`} key={k}>
              <h3>{name}<span>{ts.length}</span></h3>
              {ts.map((t) => {
                const a = agentFor(agentsById, t);
                return (
                  <button className="tc" key={t.id} onClick={() => a && !a.removed && onOpenAgent(a.id)}>
                    <span className="tm">{a && (!a.removed || a.look) && <Avatar agent={a} size="sm" />}{a ? a.name : ''}{a && a.removed ? ' (left)' : ''} · {cardTime(t)}{t.status === 'failed' ? ' · failed' : ''}</span>
                    <span className="t">{t.title}</span>
                    {t.status === 'working' && t.progress != null && <span className="meter" style={{ display: 'block' }}><b style={{ width: `${t.progress * 100}%` }} /></span>}
                  </button>
                );
              })}
              {!ts.length && <div className="empty" style={{ padding: 12, fontSize: 13 }}>Nothing here</div>}
            </div>
          );
        })}
      </div>}
    </div>
  );
}
